(function () {
  'use strict';

  /* Every ranger-* section renders the <script> tag, so the page can carry a
     dozen references to this file. The browser fetches it once but executes
     each <script> element separately — without this guard each execution
     would build its own observers and add a second submit/click listener to
     every form and swatch. One namespaced flag, set on the first run. */
  if (window.montarBSignupBooted) return;
  window.montarBSignupBooted = true;

  /* Per-element bookkeeping without leaking globals or expando collisions. */
  var bound = new WeakSet();
  var teardown = new WeakMap();

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function onUnload(root, fn) {
    var list = teardown.get(root) || [];
    list.push(fn);
    teardown.set(root, list);
  }

  /* ------------------------------------------------ CONVERSION ---------- */
  /* Fired ONLY from a confirmed Klaviyo success, never on click or on a failed
     request, so a Lead always corresponds to a stored profile.

     One Lead per visitor per session by default: someone who signs up in the
     hero and again in the launch band is one person, and double-counting
     inflates the metric Meta optimises ad delivery against. The first event
     still carries content_category, so hero vs launch stays attributable.
     Set LEAD_ONCE_PER_SESSION = false to record every submission instead. */
  var LEAD_ONCE_PER_SESSION = true;
  var LEAD_SESSION_KEY = 'ranger-lp-lead-sent';

  function leadAlreadySent() {
    if (!LEAD_ONCE_PER_SESSION) return false;
    try {
      return window.sessionStorage.getItem(LEAD_SESSION_KEY) === '1';
    } catch (e) {
      /* Private mode / blocked storage: fall through and fire. */
      return false;
    }
  }

  function markLeadSent() {
    try { window.sessionStorage.setItem(LEAD_SESSION_KEY, '1'); } catch (e) {}
  }

  /* Shopify's Customer Privacy API is the source of truth for marketing
     consent where it applies. If it is present and says no, the pixel is
     skipped; if it is not on the page at all, there is no consent regime to
     honour and the event fires. */
  function marketingConsentGranted() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed();
    } catch (e) {}
    return true;
  }

  /* OpenAI Ads: only the MONTAR collection landing page, after Shopify
     permits marketing and third-party data sharing. No email in event data. */
  var OAI_PIXEL_ID = 'DihzGHruLXNgrVpuVWUkby';
  var OAI_LEAD_KEY = 'montar-b-openai-lead-sent';
  var oaiReady = false;
  var oaiLeadSent = false;

  function openAIConsentGranted() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.marketingAllowed() && cp.saleOfDataAllowed());
    } catch (e) { return false; }
  }

  function syncOpenAIConsent() {
    try {
      var allowed = openAIConsentGranted();
      if (!oaiReady && !allowed) return;
      if (!window.oaiq) {
        var q = function () { q.q.push(arguments); };
        q.q = [];
        window.oaiq = q;
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
        document.head.appendChild(script);
      }
      window.oaiq('consent', allowed);
      if (!oaiReady) {
        window.oaiq('init', { pixelId: OAI_PIXEL_ID });
        oaiReady = true;
      }
    } catch (e) { /* Measurement must never interrupt the signup. */ }
  }

  function setupOpenAI() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/the-montar-watch-collection') return;
    syncOpenAIConsent();
    document.addEventListener('visitorConsentCollected', syncOpenAIConsent);
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
          if (!error) syncOpenAIConsent();
        });
      }
    } catch (e) {}
  }

  function trackOpenAILead() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/the-montar-watch-collection') return;
    if (!openAIConsentGranted() || oaiLeadSent) return;
    try {
      if (window.sessionStorage.getItem(OAI_LEAD_KEY) === '1') return;
    } catch (e) {}
    syncOpenAIConsent();
    if (!oaiReady || typeof window.oaiq !== 'function') return;
    try {
      window.oaiq('measure', 'lead_created', { type: 'customer_action' });
      oaiLeadSent = true;
      try { window.sessionStorage.setItem(OAI_LEAD_KEY, '1'); } catch (e) {}
    } catch (e) {}
  }

  setupOpenAI();

  function trackSignupSuccess(form, email) {
    trackOpenAILead();
    var source = form.getAttribute('data-source') || 'montar-b';

    /* Klaviyo onsite: tie the browser session to the profile so browse and
       abandon flows can pick this visitor up. Not consent-gated here -
       Klaviyo already holds the subscription the visitor just opted into. */
    try {
      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', { $email: email }]);
      }
    } catch (e) {}

    if (leadAlreadySent()) return;
    if (!marketingConsentGranted()) return;

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'MONTAR B signup',
          content_category: source
        });
        markLeadSent();
      }
    } catch (e) {}
  }

  /* ======================================================= 1. SIGNUP ===== */
  /* One handler for every Ranger form, so the hero and the final launch slab
     validate, load, succeed and fail identically. */
  function bindSignup(form) {
    if (bound.has(form)) return;
    bound.add(form);

    var field = form.querySelector('[data-ranger-signup-field]');
    var input = form.querySelector('[data-ranger-signup-input]');
    var button = form.querySelector('[data-ranger-signup-button]');
    var note = form.querySelector('[data-ranger-signup-note]');
    var confirmation = form.querySelector('[data-ranger-signup-success]');
    if (!input) return;

    var idle = note ? (note.getAttribute('data-idle') || '') : '';
    var busy = false;

    function say(message, state) {
      if (!note) return;
      note.textContent = message || '';
      note.className =
          'ranger-lp__signup-note' + (state ? ' ranger-lp__signup-note--' + state : '');
    }

    function setBusy(next) {
      busy = next;
      form.setAttribute('aria-busy', next ? 'true' : 'false');
      if (button) button.disabled = next;
      input.readOnly = next;
    }

    function onSubmit(event) {
      event.preventDefault();
      if (busy) return; /* duplicate-submission guard */

      var email = (input.value || '').trim();
      if (!email || !input.checkValidity()) {
        input.setAttribute('aria-invalid', 'true');
        say(form.getAttribute('data-invalid') || 'Please enter a valid email address.', 'error');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');

      setBusy(true);
      say(form.getAttribute('data-pending') || 'Adding you to the list…', 'pending');

      var endpoint =
          'https://a.klaviyo.com/client/subscriptions/?company_id=' +
          encodeURIComponent(form.getAttribute('data-company-id') || '');

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          revision: form.getAttribute('data-revision') || '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.getAttribute('data-source') || 'montar-b',
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, properties: { montar_lp_b_signup: true } }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: form.getAttribute('data-list-id') || '' } }
            }
          }
        })
      })
          .then(function (response) {
            if (!response.ok) throw new Error('Klaviyo responded ' + response.status);
            /* Success is terminal: retire the field and keep the message. */
            if (field) field.hidden = true;
            form.setAttribute('aria-busy', 'false');
            if (confirmation) {
              say(idle);
              confirmation.hidden = false;
              confirmation.focus({ preventScroll: true });
            } else {
              say(form.getAttribute('data-success'), 'success');
              if (note) { note.setAttribute('tabindex', '-1'); note.focus(); }
            }
            trackSignupSuccess(form, email);
          })
          .catch(function () {
            say(form.getAttribute('data-error'), 'error');
            setBusy(false);
            input.focus();
          });
    }

    function onInput() {
      if (note && note.className !== 'ranger-lp__signup-note') say(idle);
      input.removeAttribute('aria-invalid');
    }

    form.addEventListener('submit', onSubmit);
    input.addEventListener('input', onInput);

    onUnload(form, function () {
      form.removeEventListener('submit', onSubmit);
      input.removeEventListener('input', onInput);
    });
  }

  function boot() {
    document.querySelectorAll('[data-montar-b-signup][data-mode="montar-b-klaviyo"]').forEach(bindSignup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function(event) {
    event.target.querySelectorAll('[data-montar-b-signup]').forEach(function(form) {
      (teardown.get(form) || []).forEach(function(fn) { fn(); });
      teardown.delete(form); bound.delete(form);
    });
  });
})();
